import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../../login-service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit {
  plansList: any;
  plansListDetails: any;
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  userID: string;
  roleID: string;
  MenuPermissions: string;
  usertypeid: string;
  menuData: any;
  menuName: any;
  menuID: any;
  type: string;
  addPlan: boolean=false;
  usertype:any;
  duration:any;
  price:any;
  num_of_days:any;
  description:any;
  message: string;
  viewed: boolean;
  searchText:any;
  rolesList: any;
  planid:any;
  selectedPlansListid=[];
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p: any;
  count: any;
 errormsg: string;
  savefilter: any; 
 constructor(private loginService:LoginService) { 
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    // this.menuData=localStorage.getItem("menuData");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
   
    this.usertypeid=localStorage.getItem("userTypeid")
    
    this.GetMenusByUserType(3);
  }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
   this.getPlans();
   this.GetRoles();
  }
  Addplans(){
    this.addPlan=true;
    this.type="New";
  }

  getPlans(){
    
    this.loginService.GetSubscriptionplans(3).subscribe(data=>
      {
        this.plansList =JSON.parse(data['_body']);
        this.plansListDetails=this.plansList;
        
       this.savefilter=this.plansListDetails;
        this.assigndynamicarray(this.plansList)
        if(this.plansListDetails.length>0){
          this.setPage(1);
        }

      });
   
 } 
 assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}
 changepagination(page:number){
   this.count=this.rowsOnPage
  console.log(this.rowsOnPage)
  this.loginService.getselectpage(this.rowsOnPage)
  this.loginService.getPager(this.plansListDetails.length, page);
  this.setPage(page)
}
 setPage(page: number) {
   this.p=page;
  this.pager = this.loginService.getPager(this.plansListDetails.length, page);
  this.count=this.pager.pageSize;
  this.pagedItems = this.plansListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.plansList = this.plansListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
}
GetRoles(){
  this.loginService.GetRoles(this.usertypeid).subscribe(data=>
    {  
            this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

if(filteRole.length>0){
  this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
  
}
});
}
GetMenusByUserType(userTypeID){
  this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
      {
  
  this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
 
  let tempdata=this.menuData;
  
  this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='plans');
 
  if(this.menuData.length>0)
    {
  this.menuName=this.menuData[0]["menu_name"];
  this.menuID=this.menuData[0]["menu_id"];
    }
  

    
  
      });
      }

      Searchtext(){
        this.plansList = this.savefilter;
       
            let tempCompany = this.plansList.filter(
              (item) => {
                return (
                  (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
                  (item.duration !== null && item.duration.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
                  (item.price !== null && item.price.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
                );
              }
        
            );
            this.plansList = tempCompany;
            this.assigndynamicarray(tempCompany)
            if(this.searchText !== ""){
              this.plansListDetails = tempCompany;
              this.setPage(1);
          }else{
              this.plansListDetails = this.savefilter;
              this.assigndynamicarray(this.plansList)
              this.setPage(1);
          }
            // if(this.searchText=="")
            // {
            //   this.assigndynamicarray(this.plansList)
            //   this.setPage(1)
            //  this.getPlans();
            // }
           
      }
      selectRow(id,e){
        if(e.target.checked){
         this.selectedPlansListid.push(e.target.id)
        }
        else{
         var index = this.selectedPlansListid.indexOf(e.target.id);
        this.selectedPlansListid.splice(index,1)
        }
      }
      DeleteSelected(){
       if(this.selectedPlansListid.length==0){
         return;
       }
       else{
         event.stopPropagation();
         Swal.fire({
           title: 'Are you sure?',
           text: 'You want to delete the selected rows' ,///
           icon: 'warning',
           showCancelButton: true,
           confirmButtonText: 'Yes',
           cancelButtonText: 'No'
         }).then((result) => {
           if (result.value) {
             this.deleterows(this.selectedPlansListid);//
           } else if (result.dismiss === Swal.DismissReason.cancel) {
       
           }
         })
       }
      }
      deleterows(list){
     for(var i=0;i<list.length;i++){
       this.delete(list[i],'d');
       this.selectedPlansListid=[];
     }
      }
     /* Delete a record from the skills table by passing its id*/
deleteplan(row,isactive,text){
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to '+text+' this plan:' + row.duration,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(row.id,isactive);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}
cancel(){
  this.usertype="";
  this.duration="";
  this.price="";
  this.description="";
  this.num_of_days="";
  this.addPlan=false;
}
delete(ID,isactive) {
  const json={
    planid:ID,
    isactive:isactive
  }
  this.loginService.Deleteplans(json).subscribe(data => {
 
   //  Swal.fire("Deleted successfully")    
           if(isactive=='d'){
          this.loginService.showSuccess("Deleted Successfully","");

        }
       else if(isactive=='y'){
        this.loginService.showSuccess("Activated Successfully","");

       }
       else{
        this.loginService.showSuccess("Deactivated Successfully","");

       }
    this.getPlans();
    setTimeout(() => {
      this.message = "";
    }, 1000);
  
  })
}
viewplan(p){
  this.type="View";
  this.addPlan=true;
  this.viewed=true;
  this.usertype=p.user_type;
  this.duration=p.duration;
  this.price=p.price;
  this.num_of_days=p.num_of_days;
  this.description=p.description;
}
edit(p){
  this.type="Edit";
  this.planid=p.id;
  this.addPlan=true;
  this.viewed=false;
  this.usertype=p.user_type;
  this.duration=p.duration;
  this.price=p.price;
  this.num_of_days=p.num_of_days;
  this.description=p.description;
}
savePlans(){
  var initiatorPlans=this.plansList.filter(x=>x.user_type=='initiator')
  if(this.usertype=='initiator'){
    if(initiatorPlans.length>=3){
      this.errormsg="Initiator Plans cannot exceed 3"
      // Swal.fire("Initiator Plans cannot exceed 3");
      return;
    }else{this.errormsg=""}
  }

  var collaboratorPlans=this.plansList.filter(x=>x.user_type=='collaborator')
  if(this.usertype=='collaborator'){
    if(collaboratorPlans.length>=3){
      
      this.errormsg="Collaborator Plans cannot exceed 3"
      // Swal.fire("Collaborator Plans cannot exceed 3");
      return;
    }else{this.errormsg=""}
  }
  if(this.usertype==""||this.usertype==undefined||this.duration==""||this.duration==undefined||
  this.price==""||this.price==undefined || this.num_of_days==""||this.num_of_days==undefined
  ||this.description==""||this.description==undefined){return;}
  this.errormsg="";
  const json={
    planid:this.planid,
   usertype:this.usertype,
   duration:this.duration,
   price:this.price,
   num_of_days:this.num_of_days,
   description:this.description,
   updatedby:"Admin",
   createdby:'Admin'
  };
  
  this.loginService.Saveplans(json).subscribe((dataJson) => {
   
   if (dataJson['_body'].toString() === 'true') {
    if(this.type== "New"){
      // Swal.fire("Saved Successfully");
      this.loginService.showSuccess("Saved successfully!",'');
      setTimeout(() => {
        this.message = "";
      }, 5000);
      }
      else if(this.type==="Edit"){
        // Swal.fire("Updated Successfully");
        this.loginService.showSuccess("Updated successfully!",'');
      }
      
   
  
   setTimeout(() => {
     this.message = "";
   }, 5000);
   
   this.getPlans();
   //this.setPage(1);
 }
 if(this.type=="New"){
   this.usertype="";
   this.duration="";
   this.price="";
   this.description="";
   this.num_of_days="";
 }
this.addPlan=false;
this.getPlans();
   });
  
}
}
